module.exports = __webpack_public_path__ + "img/Art08-20110076-001.ab9de257.jpg";